import { FC } from 'react';
import { AffordabilityIncomeTable, AffordabilitySpotTable } from 'components';
import { AffordabilityResultsHeader } from './Components/AffordabilityResultsHeader';
import { AffordabilityResultsLeftTable } from './Components/AffordabilityResultsLeftTable';
import { Grid } from '@mui/material';

export const AffordabilityResults: FC = () => {
  return (
    <>
      <AffordabilityResultsHeader />

      <Grid container rowSpacing={4} columnSpacing={2}>
        <AffordabilityResultsLeftTable />
        <Grid item xs={12} md={6} lg={6}>
          <AffordabilitySpotTable />
          <AffordabilityIncomeTable />
        </Grid>
      </Grid>
    </>
  );
};
